import _ from 'lodash';
import moment from 'moment-timezone';

export const getSpecialHoursDays = (specialHours, timezone) => {
  const upcomingSpecialHours = _.filter(specialHours, (specialHoursItem) => {
    const specialHoursItemEndDate = moment.tz(specialHoursItem.endDate, timezone);
    const today = moment().tz(timezone).startOf('day');
    return today.isSameOrBefore(specialHoursItemEndDate);
  });
  const upcomingSpecialHoursPerDay = _.map(upcomingSpecialHours, 'hoursPerDay');
  const flattenedSpecialHoursPerDay = _.flattenDeep(upcomingSpecialHoursPerDay);

  return _.compact(flattenedSpecialHoursPerDay);
};

export const getEffectiveHours = (pickupHours, deliveryHours, specialHours, timezone) => {
  /**
   * When using updated ordering/hours settings, the top-level effectiveHours
   * object is irrelevant, as effectiveHours object nested in hoursSettings
   * are used.
   * It would be possible to wrangle the data to make this work, but the field
   * isn't used anyway. -- RTL, 8/6/2021
   */
  const usingUpdatedHoursSettings = _.some(
    specialHours,
    (specialHoursSet) => _.has(specialHoursSet, 'specialOperatingHours') && !_.has(specialHoursSet, 'hoursPerDay')
  );

  if (!specialHours || usingUpdatedHoursSettings) {
    return {
      pickupHours,
      deliveryHours,
    };
  }

  const effectivePickupHours = {};
  const effectiveDeliveryHours = {};
  const specialHoursDays = getSpecialHoursDays(specialHours, timezone);

  const specialHoursThisWeek = _.filter(_.compact(specialHoursDays), ({ date }) =>
    moment.tz(date, timezone).isSame(moment().tz(timezone), 'week')
  );

  if (specialHoursThisWeek) {
    _.forEach(specialHoursThisWeek, (day) => {
      _.set(effectivePickupHours, moment.tz(day.date, timezone).format('dddd'), day.pickupHours);
      _.set(effectiveDeliveryHours, moment.tz(day.date, timezone).format('dddd'), day.deliveryHours);
    });
  }

  return {
    pickupHours: {
      ...pickupHours,
      ...effectivePickupHours,
    },
    deliveryHours: {
      ...deliveryHours,
      ...effectiveDeliveryHours,
    },
  };
};
